export const TitleText = [
    'Our platform is inspired by a highly skilled curation team with deep knowledge in creating experiences through art.',
    'This expertise allows us to create skilfully crafted collections of quality artwork. When you subscribe to our Textura Pro Advanced plan you gain access to personalised playlists, specifically tailored to your industry and requirements.'
]